var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55515 0.976563C2.58129 0.976616 2.60716 0.981817 2.63129 0.991871C2.65542 1.00192 2.67733 1.01663 2.69577 1.03516L3.74655 2.08594C3.78382 2.12325 3.80475 2.17383 3.80475 2.22656C3.80475 2.2793 3.78382 2.32987 3.74655 2.36719L1.59226 4.52344C1.56192 4.55306 1.52292 4.57222 1.48093 4.57813L0.230929 4.77734C0.199956 4.78236 0.168238 4.77998 0.138361 4.77039C0.108484 4.76081 0.081296 4.74431 0.0590154 4.72221C0.0367348 4.70012 0.0199937 4.67308 0.0101567 4.64329C0.000319819 4.61349 -0.00233415 4.5818 0.0024129 4.55078L0.201632 3.30078C0.20847 3.25925 0.228301 3.22096 0.258272 3.19141L2.41452 1.03516C2.43297 1.01663 2.45488 1.00192 2.47901 0.991871C2.50313 0.981817 2.52901 0.976615 2.55515 0.976562V0.976563Z",
    fill: "#475662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53158 4.76837e-07C3.55772 5.31415e-05 3.58359 0.00525469 3.60772 0.0153084C3.63185 0.0253621 3.65376 0.0400712 3.67221 0.0585947L4.72104 1.11133C4.73978 1.12984 4.75466 1.15189 4.76482 1.1762C4.77498 1.2005 4.78021 1.22659 4.78021 1.25293C4.78021 1.27928 4.77498 1.30536 4.76482 1.32966C4.75466 1.35397 4.73978 1.37602 4.72104 1.39453L4.28744 1.82813C4.25013 1.86539 4.19955 1.88632 4.14682 1.88632C4.09408 1.88632 4.0435 1.86539 4.00619 1.82813L2.95346 0.777344C2.91619 0.740031 2.89526 0.689453 2.89526 0.636719C2.89526 0.583986 2.91619 0.533408 2.95346 0.496094L3.39096 0.0585942C3.4094 0.0400707 3.43131 0.0253621 3.45544 0.0153084C3.47957 0.00525469 3.50544 5.26647e-05 3.53158 0V4.76837e-07Z",
    fill: "#475662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.78022,
    height: 4.7799,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditText);
export default __webpack_public_path__ + "static/media/icon_edit_text.1f62367306bb8b022ae557eab0687f5c.svg";
export { ForwardRef as ReactComponent };